<script>
    export let chemical_group_options;
    export let selected_chemical_group;
    export let chemical_substance_options;
    export let selected_chemical_substance;
    export let survey_cycle_options;
    export let selected_survey_cycle;
    export let current_year;
    export let matrix_options;
    export let selected_matrix;
    export let prairie_only_fields;
    export let midpoint;
    export let scale;
    export let midpoints;
    export let scales;
    export let show_help_modal;
    export let show_prairie_filter_modal;

    import Dropdown from './Dropdown.svelte';
    import HorizontalButtonSelection from './HorizontalButtonSelection.svelte';
    import HorizontalTextSelection from './HorizontalTextSelection.svelte';
    import IconSelect from './IconSelect.svelte';
    import InfoIcon from './InfoIcon.svelte';
    import SelectionTitle from './SelectionTitle.svelte';
    import ToggleSlider from './ToggleSlider.svelte';
</script>

<div>
    <div id="visualization__controls">
        <div id="visualization__control-chemical-group" class="visualization__control">
            <SelectionTitle title="Chemical Group"/> 
            <Dropdown 
                id="chemical-group__dropdown" 
                options={chemical_group_options} 
                bind:selected={selected_chemical_group} 
            />
        </div>
        <div id="visualization__control-chemical-substance" class="visualization__control">
            <SelectionTitle title="Chemical Substance"/> 
            <Dropdown 
                id="chemical-substance__dropdown" 
                options={chemical_substance_options} 
                bind:selected={selected_chemical_substance} 
            />
        </div>
        <div id="visualization__control-cycle" class="visualization__control">
            <SelectionTitle title="Survey Cycle"/> 
            <HorizontalButtonSelection 
                available_options={survey_cycle_options}
                all_options={['1','2','3','4','5','6']}
                height=40
                width=40
                {current_year}
                bind:selected={selected_survey_cycle}
            />
        </div>
        <div id="visualization__control-matrix" style="height:70px;">
            <IconSelect 
                icons={matrix_options}
                bind:selected={selected_matrix}
            />
        </div>
        <div id="visualization__control-prairie" class="visualization__control">
            <SelectionTitle
                title="Prairies
                Data Filter"
                click_action={show_prairie_filter_modal}
                style="white-space: pre-line; line-height: 1.25;"
            /> 
            <ToggleSlider 
                bind:selected={prairie_only_fields}
            />
        </div>
        <div id="visualization__control-midpoint">
            <HorizontalTextSelection 
                desc="Midpoint" 
                options={midpoints}
                bind:selected={midpoint}
            />
        </div>
        <div id="visualization__control-scale">
            <HorizontalTextSelection 
                desc="Scale To" 
                options={scales}
                bind:selected={scale}
            />
        </div>
        <div 
            id="visualization__control-help"
            on:click={show_help_modal}
        >
            How to read the charts
        </div>
    </div>
    <div id="visualization__prairies-indicator">
        {#if prairie_only_fields}
            <span>Chemical group and substance options are currently limited to substances where prairies data is available.</span>
            <InfoIcon
                click_action={show_prairie_filter_modal}
            />
        {/if}
    </div>
</div>

<style>
    #visualization__controls {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
        align-items: end;
        gap: 4px 8px;
    }
    .visualization__control {
        display: flex;
        flex-direction: column;
    }
    #visualization__control-prairie {
        align-self: flex-start;
    }
    #visualization__control-matrix {
        display: flex;
    }
    #visualization__control-help {
        color: #5FCEEA;
        font-size: 11px;
        white-space: nowrap;
        cursor: pointer;

        grid-column-start: 5;
    }
    #visualization__prairies-indicator {
        display: flex;
        height: 24px;
        font-size: 12px;
        margin-top: 12px;
    }
    #visualization__prairies-indicator span {
        margin-right: 2px;
        color: #777;
        font-weight: bold;
    }
    @media screen and (max-width: 1198px) and (min-width: 725px) {
        #visualization__controls {
            display: inline-grid;
            grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
            align-items: end;
            gap: 16px 16px;
        }
        #visualization__control-chemical-group, #visualization__control-chemical-substance {
            grid-column: span 3;
        }
        #visualization__control-cycle,
        #visualization__control-matrix,
        #visualization__control-prairie,
        #visualization__control-midpoint,
        #visualization__control-scale,
        #visualization__control-help {
            grid-column: span 2;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
    @media screen and (max-width: 724px) {
        #visualization__controls {
            display: inline-grid;
            grid-template-columns: 1fr 1fr 1fr;
            grid-template-rows: 6fr 6fr 6fr 1fr 1fr 1fr; /* 6fr to 1 fr for padding purposes */
            align-items: center;
            gap: 16px 16px;
            width: 100%;
        }
        #visualization__control-chemical-group, 
        #visualization__control-chemical-substance {
            grid-column: span 3;
        }
        #visualization__control-cycle {
            grid-column: 1 / 3;
        }
        #visualization__control-matrix {
            grid-column: 3 / 4;
        }
        #visualization__control-prairie {
            grid-row: 4 / 7;
            grid-column: 1 / 2;
        }
        #visualization__control-midpoint {
            grid-row: 4 / 5;
            grid-column: 2 / 4;
        }
        #visualization__control-scale {
            grid-row: 5 / 6;
            grid-column: 2 / 4;
        }
        #visualization__control-help {
            grid-row: 6 / 7;
            grid-column: 2 / 4;
        }
    }
</style>